const mutations = {
  setCategories(state, payload) {
    state.categories = payload
  },
  userLoggedIn(state, payload) {
    state.isUserLoggedIn = true
    state.userAuthInfo = { 
      name: payload.response.name,
      token: payload.response.token,
      message: payload.response.message,
      email: payload.response.email,
      role: payload.response.role,
      emailVerified : payload.response.email_verified,
      profileVerified : payload.response.profile_verified
    }
    if(payload.response.role == 'freelancer') {
      state.isUserActivated = payload.status  
      state.isEmailVerified = payload.isEmailVerified
    }
    if (payload.rememberMe) {
      state.expiry = null
    } else {
      let date = new Date()
      date.setDate(date.getDate() + 1)
      state.expiry = date
    }
  },
  userLoggedInFromVuex(state, payload) {
    state.isUserLoggedIn = true
    state.userAuthInfo = { 
      name: payload.userAuthInfo.name,
      token: payload.userAuthInfo.token,
      message: payload.userAuthInfo.message,
      email: payload.userAuthInfo.email,
      role: payload.userAuthInfo.role,
      emailVerified : payload.userAuthInfo.emailVerified,
      profileVerified : payload.userAuthInfo.profileVerified
    }
    if(payload.userAuthInfo.role == 'freelancer') {
      state.isUserActivated = payload.status  
      state.isEmailVerified = payload.isEmailVerified
    }
    if (payload.rememberMe) {
      state.expiry = null
    } else {
      let date = new Date()
      date.setDate(date.getDate() + 1)
      state.expiry = date
    }
  },
  userLoggedOut(state) {
    state.isUserLoggedIn = false
    state.isUserActivated = false
    state.isEmailVerified = false
    state.userAuthInfo = {}

    if (window.localStorage && window.localStorage.vuex) {
      const vuexData = JSON.parse(window.localStorage.vuex)
      if (vuexData && vuexData.auth.isUserLoggedIn) {
        vuexData.auth.isUserLoggedIn = false
        vuexData.auth.userAuthInfo = {}
        window.localStorage.setItem("vuex", JSON.stringify(vuexData))
      }
    }

    if (window.localStorage && window.localStorage.freelancerVuex) {
      const vuexData = JSON.parse(window.localStorage.freelancerVuex)
      if (vuexData && vuexData.auth.isUserLoggedIn) {
        vuexData.auth.isUserLoggedIn = false
        vuexData.auth.userAuthInfo = {}
        window.localStorage.setItem("freelancerVuex", JSON.stringify(vuexData))
      }
    }
  },
  setProfileStatus(state, status) {
    state.isEmailVerified = status
  },
  setProfileActivationStatus(state, status) {
    state.isUserActivated = status
  },
  setUserEmail(state, email) {
    state.userAuthInfo.email = email
  },
  setUserName(state, payload) {    
    if (window.localStorage && window.localStorage.vuex) {
      let vuexData = JSON.parse(window.localStorage.vuex)
      if (vuexData && vuexData.auth.isUserLoggedIn) {
        vuexData.auth.userAuthInfo.name = payload
        window.localStorage.setItem("vuex", JSON.stringify(vuexData))
      }
    }
    state.userAuthInfo.name = payload
  },
  openAlertModal(state, payload) {
    state.isAlertModalOpen = payload
  },  
  openLoginSelectionModal(state, payload) {
    state.isLoginSelectionModalOpen = payload
  },
  openSignupSelectionModal(state, payload) {
    state.isSignupSelectionModalOpen = payload    
  },
  LoginSelectionMode(state, payload) {
    state.LoginSelectionMode = payload
  },
  openLoginModal(state, payload) {
    state.isLoginModalOpen = payload
  },
  openForgetPasswordModal(state, payload) {
    state.isForgetPasswordModalOpen = payload
  }
}

export default mutations
